export const EATEN = "eaten";
export const GHOST = "ghost";
export const NORMAL = "normal";
export const SUPER = "super";
export const FADED = "faded";
